import AvatarGenerator from "../AvatarGenerator/AvatarGenerator";
import Box from "../Box";
import CustomAvatar from "../CustomAvatar";
import type { LeaderboardAvatarType } from "./types";

export type LeaderboardAvatarProps = {
	username: string;
	size?: number;
	avatarImage?: string;
	avatarType?: LeaderboardAvatarType;
};

export const LeaderboardAvatar = ({
	username,
	size = 36,
	avatarImage,
	avatarType,
}: LeaderboardAvatarProps) => {
	if (avatarImage && !avatarType) {
		return <CustomAvatar size={size} avatar={avatarImage} />;
	}

	return (
		<Box width={size} height={size} overflow="hidden" borderRadius={99}>
			<AvatarGenerator
				firstName={username}
				lastName={username}
				size={size}
				avatarType={avatarType}
				customStyle={{ position: "static" }}
			/>
		</Box>
	);
};
